/** Minimal Login Info block stored in aiPromptPart1 on each project template. */

export interface LoginInfoFields {
  username: string;
  password: string;
}

export function parseLoginInfoPrompt(text: string): LoginInfoFields {
  const raw = String(text || "");
  const usernameMatch = raw.match(/^Username:\s*(.*)$/im);
  const passwordMatch = raw.match(/^Password:\s*(.*)$/im);
  return {
    username: (usernameMatch?.[1] || "").trim(),
    password: (passwordMatch?.[1] || "").trim(),
  };
}

export function formatLoginInfoPrompt(fields: LoginInfoFields): string {
  const username = fields.username.trim();
  const password = fields.password.trim();
  if (!username && !password) return "";
  const lines: string[] = [];
  if (username) lines.push(`Username: ${username}`);
  if (password) lines.push(`Password: ${password}`);
  return lines.join("\n");
}

export function loginInfoPreviewMarkdown(text: string): string {
  const { username, password } = parseLoginInfoPrompt(text);
  if (!username && !password) return "_No login credentials configured._";
  const lines = ["**Login Info**", ""];
  if (username) lines.push(`- Username: \`${username}\``);
  if (password) lines.push(`- Password: \`••••••\``);
  return lines.join("\n");
}
